export default __webpack_public_path__ + "static/media/desktop_filtres.ffaeec0b.svg";